/**
 * DiscoveryFanbases 스타일
 * @description 시안 `3041:2429`. 머리줄과 카드줄 사이 12.
 *
 *   폰에서 카드 폭은 시안 값(96)을 그대로 쓴다. 얼굴 48 과 두 줄짜리 글이 들어가는 자리라
 *   넓힐 이유가 없고, 넓히면 얼굴만 외따로 떠 보인다.
 *
 *   넓은 화면은 데스크톱 시안을 따른다 — 여섯 장이 줄을 채우고, 각 장은 테두리 있는
 *   카드(`Card` 의 neutral · radius lg · inset lg 와 같은 값)에 앉는다. 폰 시안에는 테두리가
 *   없으므로 폰에서는 그리지 않는다.
 */
export const discoveryFanbaseStyles = {
  root: "flex w-full flex-col gap-[var(--fw-space-gap-md)]",
  card: [
    "w-[96px]",
    "tablet:w-[calc((100cqw_-_var(--fw-inset-tab)*2_-_var(--fw-space-gap-md)*5)/6)]",
    "tablet:rounded-[var(--fw-radius-lg)] tablet:border-[length:var(--fw-border-sm)] tablet:border-[var(--fw-color-border-subtle)]",
    "tablet:bg-[var(--fw-color-surface-neutral-primary)] tablet:p-[var(--fw-space-inset-lg)]",
    /* 마우스가 올라오면 살짝 뜬다 — 그림자 색은 토큰(`effect.shadow`) */
    "tablet:transition-[transform,box-shadow] tablet:duration-300 motion-safe:tablet:hover:-translate-y-[var(--fw-space-gap-xxs)] tablet:hover:shadow-[0_12px_32px_var(--fw-color-effect-shadow)]",
  ].join(" "),
};

/** 시안의 얼굴 크기 48 — DS 는 그 값을 `sm` 이라 부른다(`md` 는 80) */
export const DISCOVERY_FANBASE_AVATAR_SIZE = "sm" as const;
/** 얼굴 이미지를 내려받을 폭 — 48 짜리 자리다 */
export const DISCOVERY_FANBASE_AVATAR_WIDTH = 48;

/**
 * 프로필 시트 안 — 얼굴을 크게(md 80) 가운데 두고 이름 · 아이디 · 이유를 쌓는다. 앱의
 * 프로필 머리와 같은 순서다.
 */
export const discoveryFanbaseProfileStyles = {
  root: "flex flex-col items-center gap-[var(--fw-space-gap-md)] text-center",
  texts: "flex w-full flex-col items-center gap-[var(--fw-space-gap-xxs)]",
  name: "fw-h3 w-full truncate text-[var(--fw-color-content-neutral-primary)]",
  username: "fw-caption text-[var(--fw-color-content-neutral-tertiary)]",
  reason:
    "fw-b2 mt-[var(--fw-space-gap-sm)] text-[var(--fw-color-content-neutral-secondary)]",
  /** 바텀시트에는 footer 슬롯이 없다 — 본문 아래에 같은 간격으로 붙인다 */
  sheetFooter: "mt-[var(--fw-space-gap-xl)]",
};

export const DISCOVERY_FANBASE_PROFILE_AVATAR_SIZE = "md" as const;
export const DISCOVERY_FANBASE_PROFILE_AVATAR_WIDTH = 80;
